export default "__VITE_ASSET__BH2e0j$U__"